// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2n_0q","toggle":"styles_toggle__wvZb3","preview":"styles_preview__152qE"};